import jwtDecode from "jwt-decode";

interface DecodedToken {
    exp: number;
    nameid: string;
    unique_name: string;
    role: string | string[];
}

export function buildUserFromToken(token: string, baseUser: any = {}) {
    const decoded = jwtDecode<DecodedToken>(token);

    const roles = Array.isArray(decoded.role) ? decoded.role : [decoded.role];
    const isAdmin = roles.includes("Admin");

    const expiration = new Date(decoded.exp * 1000);

    const data = {
        ...baseUser,
        id: decoded.nameid.trim().toUpperCase(),
        mobile: decoded.unique_name,
        jwtToken: token,
        roles,
        isAdmin,
        expiration,
    };


    return data;
}
